import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { AppSessionService } from "../../app-session/app-session.service";

import { ProductSupplierDTO } from "src/app/models/Products/productSupplierDTO";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { setAdvancedFilterQuery, setSimpleFilterQuery } from "src/app/shared/utils/tableUtils";
import { GridUtils } from "src/app/shared/utils/gridUtils";
import { ProductPriceSchedulingDTO } from "src/app/models/Products/priceSchedulingDTO";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class ProductPriceSchedulingService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}
    
  private PRODUCT_PRICE_SCHEDULING_URL = this.appSession.baseUrl + "/api/v1/siteProductPriceSchedulers";

  getPriceSchedulerList(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    const url = paging
      ? this.buildDataUrl(paging, "/search?")
      : `${this.PRODUCT_PRICE_SCHEDULING_URL}/search`;

    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  getProductPriceScheduling(token: string): Observable<any> {
    return this.http.get<any>(
      `${this.PRODUCT_PRICE_SCHEDULING_URL}/${token}`,
      {headers: {"content-type": "application/json"}}
    );
  }

  createProductPriceScheduling(priceScheduling: ProductPriceSchedulingDTO): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(priceScheduling);
    const url = `${this.PRODUCT_PRICE_SCHEDULING_URL}/create`;
    return this.http.post<any>(url, data, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }


  createProductPriceSchedulingBatch(priceScheduling: ProductPriceSchedulingDTO[]): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(priceScheduling);
    const url = `${this.PRODUCT_PRICE_SCHEDULING_URL}/create/batch`;
    return this.http.post<any>(url, data, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  deleteProductpriceScheduling(priceSchedulingToken: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.PRODUCT_PRICE_SCHEDULING_URL}/delete/${priceSchedulingToken}`;
    return this.http.delete<any>(url, { headers }).pipe(
      catchError((error) => throwError(error))
    );
  }

  cancelProductPriceScheduling(priceSchedulingToken: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.PRODUCT_PRICE_SCHEDULING_URL}/cancel/${priceSchedulingToken}`;
    return this.http.put<any>(url, { headers }).pipe(
      catchError((error) => throwError(error))
    );
  }

  // Grid filter helpers block
  private buildDataUrl(pagingArgs: any, path: string): string {
    let baseQueryString = `${this.PRODUCT_PRICE_SCHEDULING_URL}${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query += scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;
    baseQueryString += query;

    return baseQueryString;
  }
}
